import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import WhatsAppButton from './components/WhatsAppButton';
import CouponPopup from './components/CouponPopup';
import CouponPopupDemo from './components/CouponPopupDemo';
import useCouponPopup from './hooks/useCouponPopup';
import Home from './pages/Home';
import WhyOsop from './pages/WhyOsop';
import Placement from './pages/Placement';
import Hire from './pages/Hire';
import Enquire from './pages/Enquire';
import Franchise from './pages/Franchise';
import CourseList from './pages/CourseList';
import JobOriented from './pages/JobOriented';
import CourseDetail from './pages/CourseDetail';
import Tutorials from './pages/Tutorials';
import MasterclassSolid from './pages/MasterclassSolid';
import MasterclassDataScience from './pages/MasterclassDataScience';
import MasterclassFoundationDsaC from './pages/MasterclassFoundationDsaC';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import Analytics from './pages/admin/Analytics';
import ProtectedRoute from './pages/admin/ProtectedRoute';
import AdminHiringRequests from './pages/admin/AdminHiringRequests';
import AdminPromotionalSlides from './pages/admin/AdminPromotionalSlides';
import AdminFranchiseHeroImages from './pages/admin/AdminFranchiseHeroImages';
import AdminFranchiseEnquiries from './pages/admin/AdminFranchiseEnquiries';
import AdminContacts from './pages/admin/AdminContacts';
import AdminWorkshopRegistrations from './pages/admin/AdminWorkshopRegistrations';
import AdminPlacementResumes from './pages/admin/AdminPlacementResumes';
import AdminCoupons from './pages/admin/AdminCoupons';
import Contact from './pages/Contact';

// Wrapper component to access location
const AppContent = () => {
  const { showPopup } = useCouponPopup();

  return (
        <div className="flex flex-col min-h-screen bg-gray-50 dark:bg-gray-900 theme-transition antialiased">
      {showPopup && <CouponPopup />}
          <Navbar />
          <main className="flex-grow relative">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/why-osop" element={<WhyOsop />} />
              <Route path="/placement" element={<Placement />} />
              <Route path="/hire" element={<Hire />} />
              <Route path="/enquire" element={<Enquire />} />
              <Route path="/franchise" element={<Franchise />} />
              <Route path="/courses/:category" element={<CourseList />} />
              <Route path="/course/:courseSlug" element={<CourseDetail />} />
              <Route path="/job-oriented-course" element={<JobOriented />} />
              <Route path="/tutorials" element={<Tutorials />} />
              <Route path="/masterclass-solid" element={<MasterclassSolid />} />
              <Route path="/masterclass-data-science" element={<MasterclassDataScience />} />
              <Route path="/masterclass-foundation-dsa-c" element={<MasterclassFoundationDsaC />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/coupon-demo" element={<CouponPopupDemo />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              } />
              <Route path="/admin/analytics" element={
                <ProtectedRoute>
                  <Analytics />
                </ProtectedRoute>
              } />
              <Route path="/admin/hiring-requests" element={
                <ProtectedRoute>
                  <AdminHiringRequests />
                </ProtectedRoute>
              } />
              <Route path="/admin/promotional-slides" element={
                <ProtectedRoute>
                  <AdminPromotionalSlides />
                </ProtectedRoute>
              } />
              <Route path="/admin/franchise-hero-images" element={
                <ProtectedRoute>
                  <AdminFranchiseHeroImages />
                </ProtectedRoute>
              } />
              <Route path="/admin/franchise-enquiries" element={
                <ProtectedRoute>
                  <AdminFranchiseEnquiries />
                </ProtectedRoute>
              } />
              <Route path="/admin/contacts" element={
                <ProtectedRoute>
                  <AdminContacts />
                </ProtectedRoute>
              } />
              <Route path="/admin/workshop-registrations" element={
                <ProtectedRoute>
                  <AdminWorkshopRegistrations />
                </ProtectedRoute>
              } />
              <Route path="/admin/placement-resumes" element={
                <ProtectedRoute>
                  <AdminPlacementResumes />
                </ProtectedRoute>
              } />
              <Route path="/admin/coupons" element={
                <ProtectedRoute>
                  <AdminCoupons />
                </ProtectedRoute>
              } />
            </Routes>
          </main>
          <Footer />
          <WhatsAppButton />
        </div>
  );
};

function App() {
  return (
    <ThemeProvider>
      <Router>
        <ScrollToTop />
        <AppContent />
      </Router>
    </ThemeProvider>
  );
}

export default App; 